import { categories } from "@/mocks/site";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface TopicSectionProps {
  onSelectCategory: (key: string) => void;
}

export default function TopicSection({ onSelectCategory }: TopicSectionProps) {
  return (
    <section id="topics" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="TOPIC INDEX"
          title="按主题查争议池"
          desc="每一条投稿都会归入以下四类争议池。先想清楚自己最在意哪一类，再有的放矢地翻档案。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, index) => (
            <Reveal key={cat.key} delay={index * 80}>
              <button
                type="button"
                onClick={() => onSelectCategory(cat.key)}
                className="group relative flex h-full w-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-300 md:p-6"
              >
                <span className="pointer-events-none absolute -right-2 -top-4 font-heading text-6xl font-black text-background-200 transition-colors group-hover:text-primary-100">
                  0{index + 1}
                </span>
                <span className="relative flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${cat.icon} text-2xl leading-none`}></i>
                </span>
                <h3 className="relative mt-5 font-heading text-lg font-bold text-foreground-950">{cat.label}</h3>
                <p className="relative mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <div className="relative mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-xs text-foreground-500">
                    收录 <strong className="font-heading text-base text-foreground-900">{cat.count}</strong> 条
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap font-label text-xs text-primary-600">
                    查看
                    <i className="ri-arrow-right-line text-sm leading-none"></i>
                  </span>
                </div>
                <span className="relative mt-3 rounded bg-accent-100 px-2 py-1 font-label text-xs text-accent-900">
                  提示：{cat.hint}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}